import React, { useState } from 'react';
import '../Styles/TokenMenu.css';

const AmountMenu = ({ options, placeholder, onSelect, selectedToken }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);

    const handleOptionClick = (option) => {
        setSelectedOption(option);
        onSelect(option);
        setIsOpen(false);  // Close the dropdown when an option is clicked
    };
    return (
        <div className="dropdownToken" onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
            <div className="selectedToken-value flex-container">
                <span>{selectedToken ? selectedToken : placeholder}</span>
            </div>
            {isOpen && (
                <div className="dropdownToken-options">
                    {options.map((amount, index) => (
                        <div key={index} className="dropdownToken-option flex-container" onClick={() => handleOptionClick(amount)}>
                            <span>{amount}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );       
}

export default AmountMenu;
